import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import {
  ShipmentPlannerProfileReportInitialState,
  ShipmentPlannerProfileReportLoad,
} from './shipment-planner-profile-report.actions';
import { ProfileReportItem } from '../../../../models';
import { ShipmentPlannerProfileReportState } from './shipment-planner-profile-report.state';
import { ShipmentProfileReport } from '../models';

@Injectable({ providedIn: 'root' })
export class ShipmentPlannerProfileReportFacade implements LoadDataFacade, SetInitialStateFacade {
  report$: Observable<ShipmentProfileReport> = this.store.select(ShipmentPlannerProfileReportState.getReport);
  loaded$: Observable<boolean> = this.store.select(ShipmentPlannerProfileReportState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new ShipmentPlannerProfileReportLoad());
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentPlannerProfileReportInitialState());
  }

  setReportRequiredFields(report: ShipmentProfileReport): ShipmentProfileReport {
    const result = {} as ShipmentProfileReport;
    Object.keys(report).forEach((reportKey: string) => {
      result[reportKey] = Array.isArray(report[reportKey])
        ? report[reportKey].filter((item: ProfileReportItem) => item.required)
        : report[reportKey];
    });
    return result;
  }
}
